export default __webpack_public_path__ + "static/media/Leggings of Vernant Fury.d29aeda2.jpg";